var DatedFlight = (function () {
	'use strict';

	return (function () {

		var _destinationSearchedForText, _originNodeId, _destinationNodeId, _originCode, _destinationCode, _departureDate, _returnDate, _classOfTravel,
            _friendlyDestinationName, _isNewSearch, _airlineId, _loadingTemplateId, _loadingCompiledTemplate, _searchResultsTemplateId,
            _searchResultsCompiledTemplate, _resultsHtml, _resultsLoaderId, _resultsPlaceHolderId, _hasFullPackage = false, _loaderJson, _searchComplete = false, _loaderAnimComplete = false, _mainSearchJson = null,
            _amadeusITFareOnlySearchJson = null, _errorText;
	//	var _destinationSearchedForText, _originNodeId, _destinationNodeId, _originCode, _destinationCode, _departureDate, _returnDate, _classOfTravel,
    //_friendlyDestinationName, _isNewSearch, _airlineId, _loadingTemplateId, _loadingCompiledTemplate, _searchResultsTemplateId,
    //_searchResultsCompiledTemplate, _resultsHtml, _resultsLoaderId, _resultsPlaceHolderId, _packagePriceTemplateId, _packagePriceCompiledTemplate,
    //_packagePriceHtml, _hasFullPackage = false, _loaderJson, _searchComplete = false, _loaderAnimComplete = false, _mainSearchJson = null,
    //_amadeusITFareOnlySearchJson = null, _errorText;

		var Search = (function () {

			return (function () {

				function go() {
                    
				    // the fullscreen loader should overtake hte page here...
				    //jQuery('body').css('overflow', 'hidden'); // fadein new full screen loader
				    if ($('body').height() < 800) {
				        $('.fullscreen-loader').css('overflow-y', 'scroll');
				    }

					if (_validateSearchCriteria()) {

						//KICKOFF THE MAIN FLIGHT SEARCH
					    _performSearch();
                         
						//COMPILE TEMPLATE FOR LOADER
						if (_loadingCompiledTemplate === undefined) {
							_loadingCompiledTemplate = Handlebars.compile(jQuery(_loadingTemplateId).html());
						}

						//CREATE BASIC JSON FOR "Enjoy big savings too on hotels throughout {{DestinationName}}"
						_loaderJson = JSON.parse('{"DestinationName":"' + _friendlyDestinationName + '"}');
						LotusGroup.DOM.el(_resultsLoaderId).innerHTML = _loadingCompiledTemplate(_loaderJson);

						//USE DELAY TO SHOW EACH PRELOADER AFTER A GIVEN PERIOD. THESE DELAYS ARE TOTAL ms FROM PAGE LOAD NOT CUMULATIVE
						//jQuery('#jsresultsloader').delay(0).fadeIn(100);
						//jQuery('#jshotelresultsloader').delay(2000).fadeIn(100);
						//jQuery('#jsgreatserviceloader').delay(6000);

						//jQuery('#jsgreatserviceloader').fadeIn(100, function () {
						//	jQuery('#jsgreatserviceloader').delay(4000);
						//	jQuery('#jsgreatserviceloader').fadeIn(0, function () {
						//	    _loaderAnimComplete = true;

						//	    //jQuery('.fullscreen-loader').fadeOut(); // fadeout new full screen loader
						//	    //jQuery('body').css('overflow', 'auto'); // fadeout new full screen loader

						//		if (_searchComplete) {
						//			//IF THE LOADER ANIM HAS FINISHED AND THE SEARCH IS COMPLETE, SHOW THE RESULTS
						//			_displayResults();
						//		} else if (typeof _errorText !== 'undefined' && _errorText !== undefined && _errorText !== '') {
						//		    jQuery('.fullscreen-loader').fadeOut(); // fadeout new full screen loader
						//		    jQuery('body').css('overflow', 'auto'); // fadeout new full screen loader
						//			LotusGroup.DOM.el(_resultsPlaceHolderId).innerHTML = _errorText;
						//			$('#latestofferscta').animate({ 'left': '0' }, 1000);
						//		}
						//	});
					    //});

						var myTime = setInterval(function () {
						    _loaderAnimComplete = true;

						    if (_searchComplete) {
						        //IF THE LOADER ANIM HAS FINISHED AND THE SEARCH IS COMPLETE, SHOW THE RESULTS
						        _displayResults();
						        clearInterval(myTime);
						    } else if (typeof _errorText !== 'undefined' && _errorText !== undefined && _errorText !== '') {
						        jQuery('.fullscreen-loader').fadeOut(); // fadeout new full screen loader
						        jQuery('body').css('overflow', 'auto'); // fadeout new full screen loader
						        LotusGroup.DOM.el(_resultsPlaceHolderId).innerHTML = _errorText;
						        //$('#latestofferscta').animate({ 'left': '0' }, 1000);
						        clearInterval(myTime);
						    }
						}, 300);


					}

				}

				function _performSearch() {

					if (_searchResultsCompiledTemplate === undefined) {
						_searchResultsCompiledTemplate = Handlebars.compile(jQuery(_searchResultsTemplateId).html());
					}
					//if (_packagePriceCompiledTemplate === undefined) {
					//	_packagePriceCompiledTemplate = Handlebars.compile(jQuery(_packagePriceTemplateId).html());
					//}

					jQuery.ajax({
						url: [
                            '/utility/datedflightsearchjson.aspx?originnodeid=',
                            _originNodeId,
                            '&destinationnodeid=',
                            _destinationNodeId,
                            '&origincode=',
                            _originCode,
                            '&destinationcode=',
                            _destinationCode,
                            '&departuredate=',
                            _departureDate,
                            '&returndate=',
                            _returnDate,
                            '&class=',
                            _classOfTravel,
                            '&isnewsearch=',
                            _isNewSearch,
                            '&airlineid=',
                            _airlineId
						].join(''),
						cache: false,
						success: function (data) {
							try {
								if (data && !data.InvalidSearchStatus) {
									_mainSearchJson = data.SearchResults;

									_resultsHtml = _searchResultsCompiledTemplate(data.SearchResults);
									//if (data.SearchResults.Package && parseInt(data.SearchResults.Package.SellPrice, 10) > 0 && data.SearchResults.Package.Source.toUpperCase() != 'FLIGHTPRICECACHE') {
									//	//IF THE FLIGHT PRICE SOURCE FOR THE PACKAGE IS NOT FROM THE CACHE THEN DISPLAY THE PACKAGE PRICE
									//	_hasFullPackage = true;
									//	_packagePriceHtml = _packagePriceCompiledTemplate(data.SearchResults);
									//} else {
									//	_hasFullPackage = false;
									//	_packagePriceHtml = '';
									//}
									_searchComplete = true;
									if (_loaderAnimComplete) {
										//IF THE LOADER ANIM HAS FINISHED AND THE SEARCH IS COMPLETE, SHOW THE RESULTS
										_displayResults();
									}
								} else {
									_displayInvalidSearchMessage('NoFares');
								}
							} catch (e) {
								console.log(e);
								return;
							}
						},
						error: function (feedback) {
						    jQuery('.fullscreen-loader').fadeOut(); // fadeout new full screen loader
						    jQuery('body').css('overflow', 'auto'); // fadeout new full screen loader
							LotusGroup.DOM.el(_resultsLoaderId).innerHTML = '';
							_displayInvalidSearchMessage('NoFares');
							return;
						}
					});

				}

				function _validateSearchCriteria() {

					if (_destinationSearchedForText.length > 0 && _originNodeId > 0 && _destinationNodeId > 0 && _originCode.length > 0 && _destinationCode.length > 0 && _departureDate.length > 0 && _returnDate.length > 0 && _classOfTravel.length > 0 && _friendlyDestinationName.length > 0 && _isNewSearch.length > 0 && typeof ('undefined') !== _airlineId) {
						return true;
					}

				}

				function _displayResults() {

					LotusGroup.DOM.el(_resultsPlaceHolderId).innerHTML = _resultsHtml;
					//$('#latestofferscta').animate({ 'left': '0' }, 1000);

					//if (_hasFullPackage) {
					//	LotusGroup.DOM.el('additionalproductsholder').innerHTML = _packagePriceHtml;
					//	LotusGroup.DOM.el('additionalproducts').style.display = 'block';
					//}

					LotusGroup.DOM.el('searchagain').style.display = 'block';
				    jQuery('.fullscreen-loader').fadeOut(); // fadeout new full screen loader
				    jQuery('body').css('overflow', 'auto'); // fadeout new full screen loader
				    $('#showboilerplate').click(function (e) {
				        e.stopPropagation();
				        $('#boilerplate').hasClass('active') ? $('#boilerplate').css('z-index', '-2') : $('#boilerplate').css('z-index', '0');
				        $('#boilerplate').toggleClass('active');
				        $('#boilerplate').hasClass('active') ? $('#showboilerplate').fadeOut(150).delay(10).text('Less').fadeIn(150) : $('#showboilerplate').fadeOut(150).delay(10).text('More').fadeIn(150);
				    });
				    $('#boilerplate').click(function (e) {
				        e.stopPropagation();
				    });
				    $('body').click(function () {
				        if ($('#boilerplate').hasClass('active')) {
				            $('#boilerplate').css('z-index', '-2').removeClass('active');
				            $('#showboilerplate').fadeOut(150).delay(10).text('More').fadeIn(150);
				        }
				    });
				}

				function _displayInvalidSearchMessage(status) {
				    //jQuery('.fullscreen-loader').fadeOut(); // fadeout new full screen loader
				    //jQuery('body').css('overflow', 'auto'); // fadeout new full screen loader

					var errorText;

					switch (status) {
						case 'NoFares':
							if (_friendlyDestinationName.length > 0) {
							    errorText = 'We have some specially negotiated fares to ' + _friendlyDestinationName + ' which we are unable to display. Please call one of our travel experts on <div class="header__call text-center mt-double"><p class="call-now">Call us now</p><p class="call-number"><span>0330-100-2220</span></p><p class="call-answer">Calls answered in 5 seconds</p></div><div class="text-center mt-single"><a id="searchagain" class="boldlink" onclick="window.history.go(-1);">Search again ></a></div>';
							} else {
							    errorText = 'We have some specially negotiated fares to this destination which we are unable to display. Please call one of our travel experts on <div class="header__call text-center mt-double"><p class="call-now">Call us now</p><p class="call-number"><span>0330-100-2220</span></p><p class="call-answer">Calls answered in 5 seconds</p></div> for more information.<div class="text-center mt-single"><a id="searchagain" class="boldlink" onclick="window.history.go(-1);">Search again ></a></div>';
							}
							break;
						case 'Dates':
							errorText = 'The dates that have been submitted are invalid. Your return date must be after your departure date.';
							break;
						case 'DatesTooFarInFuture':
							errorText = 'The dates you have selected are too far in the future. Please check your search dates.';
							break;
						case 'Location':
							errorText = 'We\'re sorry but we do not understand your flight request, please either search again or call us for more information about your desired destination.';
							break;
						case 'TooBig':
							errorText = 'The location searched for is too large. Please search for a smaller location for example Sydney rather than Australia.';
							break;
						case 'UnknownError':
							errorText = 'An unknown error occurred, please try again.';
							break;
						default:
							errorText = 'An unknown error occurred, please try again.';
					}

					if (errorText.length > 0) {
						_errorText = errorText;
					}

				}

				function getDebug() {

					return { 'Primary': _mainSearchJson, 'IT': _amadeusITFareOnlySearchJson };

				}

				return {
					//Public Methods
					go: go,
					getDebug: getDebug
				};

			}());

		}());

		var SearchCriteria = (function () {

			return (function () {

				function setDestinationSearchedForText(a) { _destinationSearchedForText = a; }
				function setOriginNodeId(a) { _originNodeId = a; }
				function setDestinationNodeId(a) { _destinationNodeId = a; }
				function setOriginCode(a) { _originCode = a; }
				function setDestinationCode(a) { _destinationCode = a; }
				function setDepartureDate(a) { _departureDate = a; }
				function setReturnDate(a) { _returnDate = a; }
				function setClassOfTravel(a) { _classOfTravel = a; }
				function setFriendlyDestinationName(a) { _friendlyDestinationName = a; }
				function setIsNewSearch(a) { _isNewSearch = a; }
				function setAirlineId(a) { _airlineId = a; }

				return {
					setDestinationSearchedForText: setDestinationSearchedForText,
					setOriginNodeId: setOriginNodeId,
					setDestinationNodeId: setDestinationNodeId,
					setOriginCode: setOriginCode,
					setDestinationCode: setDestinationCode,
					setDepartureDate: setDepartureDate,
					setReturnDate: setReturnDate,
					setClassOfTravel: setClassOfTravel,
					setFriendlyDestinationName: setFriendlyDestinationName,
					setIsNewSearch: setIsNewSearch,
					setAirlineId: setAirlineId
				};

			}());

		}());

		var Config = (function () {

			return (function () {

				function setSearchResultsTemplateId(a) { _searchResultsTemplateId = a; }
				//function setPackagePriceTemplateId(a) { _packagePriceTemplateId = a; }
				function setLoadingTemplateId(a) { _loadingTemplateId = a; }
				function setResultsLoaderId(a) { _resultsLoaderId = a; }
				function setResultsPlaceHolderId(a) { _resultsPlaceHolderId = a; }

				return {
					setSearchResultsTemplateId: setSearchResultsTemplateId,
					//setPackagePriceTemplateId: setPackagePriceTemplateId,
					setLoadingTemplateId: setLoadingTemplateId,
					setResultsLoaderId: setResultsLoaderId,
					setResultsPlaceHolderId: setResultsPlaceHolderId
				};

			}());

		}());

		function go() {

			Search.go();

		}

		function getDebug() {

			return Search.getDebug();

		}

		return {
			go: go,
			SearchCriteria: SearchCriteria,
			Config: Config,
			getDebug: getDebug
		};

	}());

}());